import { getAccessLevelItems } from "@components/access-level/access-level-utils";
import { getCustomDateFilterOptions, getRecentDateFilterOptions } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { PROJECTS_ACCESS_LEVEL_FILTER_COLUMN, PROJECTS_LOCATION_FILTER_COLUMN, PROJECTS_SIZE_FILTER_COLUMN, PROJECTS_TAGS_FILTER_COLUMN } from "@components/projects/projects-filters/projects-filter-constants";
import { getLocationNameFilterOptions, getProjectsLocationFilterPresets } from "@components/projects/projects-filters/projects-location-filter-utils";
import { getCustomSizeFilterOptions, getProjectsSizeFilterPresets } from "@components/projects/projects-filters/projects-size-filter-utils";
import { getProjectsTagsFilterPresets, getTagFilterOptions } from "@components/projects/projects-filters/projects-tags-filter-utils";
/**
 * Returns the filter options of the column. The dates, date ranges, size ranges, cities,
 * countries and tags the user picks are options of their own, so the ones among the given filter
 * IDs are included too.
 */
export function getProjectsFilterOptions(column, filterIds) {
  if (column === PROJECTS_ACCESS_LEVEL_FILTER_COLUMN) {
    return getProjectsAccessLevelFilterOptions();
  }
  if (column === PROJECTS_SIZE_FILTER_COLUMN) {
    return {
      ...getProjectsSizeFilterPresets(),
      ...getCustomSizeFilterOptions(filterIds)
    };
  }
  if (column === PROJECTS_LOCATION_FILTER_COLUMN) {
    return {
      ...getProjectsLocationFilterPresets(),
      ...getLocationNameFilterOptions(filterIds)
    };
  }
  if (column === PROJECTS_TAGS_FILTER_COLUMN) {
    return {
      ...getProjectsTagsFilterPresets(),
      ...getTagFilterOptions(filterIds)
    };
  }
  return {
    ...getProjectsDateFilterPresets(column),
    ...getCustomDateFilterOptions(filterIds, PROJECT_TIME_GETTERS[column])
  };
}

/** Returns a filter option for each of the access levels a project can have */
export function getProjectsAccessLevelFilterOptions() {
  return Object.fromEntries(getAccessLevelItems("project").map(({
    value,
    label
  }) => [value, {
    id: value,
    label,
    hasEntityPassedFilter: project => project.accessLevel === value
  }]));
}

/** Returns the filter options for the recent days of the date the column filters the projects by */
export function getProjectsDateFilterPresets(column) {
  return getRecentDateFilterOptions(PROJECT_TIME_GETTERS[column]);
}

/** Returns the time of the date each column filters the projects by. A project never captured has none */
const PROJECT_TIME_GETTERS = {
  created: project => project.createdAt,
  lastCaptured: project => project.lastCapturedAt ?? undefined,
  lastUpdated: project => project.modifiedAt
};